import { useStyleSheet } from '../../hooks/useStyleSheet';
import { TOOLTIP_ARROW_SIZE } from './Tooltip.constants';
import { TooltipProps } from './types';

export const useStyles = ({ color }: TooltipProps) =>
  useStyleSheet((theme) => ({
    tooltipContainer: {
      position: 'absolute',
      zIndex: 10_000_000,
      backgroundColor: color ?? theme.palette.background.primary,
      borderRadius: '5px',
      padding: '6px',
      color: theme.palette.text.secondary,
      fontSize: '0.75rem',
      fontWeight: 500,
      cursor: 'default',
      whiteSpace: 'normal',
      maxWidth: 400,
      '::before': {
        position: 'absolute',
        content: '""',
        width: 0,
        height: 0,
        border: `${TOOLTIP_ARROW_SIZE}px solid transparent`,
        pointerEvents: 'none',
      },
    },
  }));
